import { render } from "./S344849.vue?vue&type=template&id=5d3807aa"
const script = {}
script.render = render

export default script